import React, { useState, useEffect } from "react";
import './CheckoutModal.css';
import CheckoutForms from "./CheckoutForms";
import { Dialog, DialogActions, DialogTitle, DialogContent, Button, Alert, CircularProgress } from "@mui/material";
import './CheckoutModal.css'
import SignatureModal from "../Billing/SignatureCap/SignatureModal";
import axios from "axios";
import { APIURL } from "../../config";

export default function CheckoutModal(props) {

    const [selectedForm, setSelectedForm] = useState(null);
    const [completedForms, setCompletedForms] = useState([]);
    const [forms, setForms] = useState([]);
    const [loadingForms, setLoadingForms] = useState(false);
    const [formError, setFormError] = useState('');
    const [retry, setRetry] = useState(0);
    const allFormsCompleted = forms.every(form => completedForms.includes(String(form.form_id)));
    const [signatureModal, setSignatureModal] = useState(false);
    const [signCaptured, setSignCaptured] = useState(false);

    useEffect(() => {
        if (!props.show || !props.isCheckedIn || !props.task_id) return;
        let active = true;
        const fetchForms = async () => {
            setLoadingForms(true);
            setFormError('');
            setCompletedForms([]);
            setSelectedForm(null);
            try {
                const checklist = await axios.post(APIURL + `/task_form/checkout/${props.task_id}`);
                const response = await axios.get(APIURL + `/customer_form/task/${props.task_id}`);
                if (!Array.isArray(response.data) || !Object.prototype.hasOwnProperty.call(checklist.data, 'form')) {
                    throw new Error('Unexpected checkout forms response');
                }
                if (!active) return;
                const available = [...(props.forms || [])];
                if (checklist.data.form && !available.some(form => String(form.form_id) === String(checklist.data.form.form_id))) {
                    // fw_forms.form_type ('form') collides with the customer_form.form_type meaning used elsewhere; strip it.
                    const { form_type, ...checklistForm } = checklist.data.form;
                    available.push(checklistForm);
                }
                setForms(available);
                setCompletedForms(response.data
                    .filter(form => {
                        try {
                            const submission = JSON.parse(form.data || '{}');
                            return Object.keys(submission.data || {}).length > 0;
                        } catch (error) {
                            return false;
                        }
                    })
                    .map(form => String(form.form_type)));
            } catch (error) {
                if (active) setFormError('Unable to load checkout forms. Please retry before checking out.');
            } finally {
                if (active) setLoadingForms(false);
            }
        }
        fetchForms();
        return () => { active = false; };
    }, [props.forms, props.task_id, props.show, props.isCheckedIn, retry]);

    useEffect(() => {
        if (signCaptured) {
            setSignCaptured(false);
            props.processCheckout();
            props.hide();
        }
    }, [signCaptured])

    async function handleSubmit() {
        if (props.isCheckedIn && (loadingForms || formError)) return;
        if (props.isCheckedIn && !allFormsCompleted) {
            alert('Please complete all forms before checking out.');
            return;
        }
        if (props.task.detail.tas_required_sig === 1 && props.task.detail.checkin) {
            setSignatureModal(true);
            return;
        }
        props.processCheckout();
        props.hide();
    };

    const onFormCreateOrExists = (cusForm) => {
        const id = String(cusForm.form_type);
        setCompletedForms(previous => previous.includes(id) ? previous : [...previous, id]);
    };

    return (
        <div>
            <Dialog
                open={props.show}
                onClose={props.hide}
                fullWidth
                maxWidth="md"
            >
                <DialogTitle>{props.modalTitle}</DialogTitle>
                <DialogContent>
                    {props.modalBody}
                    <div id="subtasks-checkout-modal-body">
                        {/* Subtask and Form Divs were here*/}
                    </div>
                    {props.isCheckedIn && loadingForms && <CircularProgress size={24} />}
                    {props.isCheckedIn && formError && <Alert severity="error" action={<Button onClick={() => setRetry(value => value + 1)}>Retry</Button>}>{formError}</Alert>}
                    {props.isCheckedIn && !loadingForms && !formError &&
                        <CheckoutForms
                            forms={forms}
                            completedForms={completedForms}
                            onSubmit={onFormCreateOrExists}
                            onEdit={onFormCreateOrExists}
                            customer_id={props.cus_id}
                            customer_name={props.customer_name}
                            task_id={props.task_id}
                            taskDetails={props.taskDetails}
                            selectedForm={selectedForm}
                            setSelectedForm={setSelectedForm}
                            user_id={props.user_id}
                            readOnly={props.readOnly}
                        />
                    }
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={props.hide}>
                        Close
                    </Button>
                    <Button
                        className="save-changes-button"
                        variant="contained"
                        disabled={props.isCheckedIn && (loadingForms || !!formError)}
                        onClick={() => handleSubmit()}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
            <SignatureModal task={props.task.detail} emp_id={props.emp_id} show={signatureModal} toggle={() => { setSignatureModal(!signatureModal) }} captured={() => { setSignCaptured(true) }} />
        </div>
    );
}